import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "modal-container" }
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "header-content" }
const _hoisted_4 = { class: "modal-title" }
const _hoisted_5 = { class: "warning-message" }
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = {
  key: 0,
  class: "upload-overlay"
}
const _hoisted_8 = { class: "documents-count" }
const _hoisted_9 = {
  key: 1,
  class: "documents-list"
}
const _hoisted_10 = { class: "document-icon" }
const _hoisted_11 = { class: "document-info" }
const _hoisted_12 = { class: "document-name" }
const _hoisted_13 = { class: "document-meta" }
const _hoisted_14 = ["onClick", "disabled"]
const _hoisted_15 = {
  key: 2,
  class: "empty-state"
}
const _hoisted_16 = { class: "modal-footer" }
const _hoisted_17 = ["accept", "disabled"]
const _hoisted_18 = { class: "description--highlighted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($props.isOpen)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "modal-overlay",
        onClick: _withModifiers($setup.close, ["self"])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h2", _hoisted_4, "Lot " + _toDisplayString($props.lotTitle) + " Documents", 1),
              _createElementVNode("div", _hoisted_5, [
                _createVNode($setup["Info"], {
                  class: "warning-icon",
                  size: 16,
                  color: "#df8c2d"
                }),
                _cache[1] || (_cache[1] = _createElementVNode("span", null, "These documents are publicly visible to buyers", -1))
              ])
            ]),
            _createElementVNode("button", {
              class: "close-button",
              onClick: $setup.close
            }, "×")
          ]),
          _createElementVNode("div", _hoisted_6, [
            ($setup.isUploading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("div", { class: "upload-text" }, "Uploading document...", -1)
                ]))]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, _toDisplayString($setup.plural($props.documents.length, "document")), 1),
            ($props.documents.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.documents, (doc) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "document-item",
                      key: doc.fileName
                    }, [
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode($setup["FileText"], { size: 32 })
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, _toDisplayString($setup.getDocumentName(doc.fileName)), 1),
                        _createElementVNode("div", _hoisted_13, _toDisplayString($setup.formatDate(doc.modifiedDate)), 1)
                      ]),
                      _createElementVNode("button", {
                        class: "delete-button",
                        onClick: ($event: any) => ($setup.handleDeleteDocument(doc)),
                        disabled: $setup.isDeleting
                      }, [
                        _createVNode($setup["Trash2"], { size: 20 })
                      ], 8, _hoisted_14)
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_15, [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("p", null, "No documents uploaded yet", -1)
                ]))]))
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("label", {
              class: _normalizeClass(["upload-button button default primary", { disabled: $setup.isUploading }])
            }, [
              _cache[4] || (_cache[4] = _createTextVNode("Upload", -1)),
              _createElementVNode("input", {
                type: "file",
                ref: "fileInput",
                onChange: $setup.handleFileUpload,
                accept: $setup.documentTypes,
                disabled: $setup.isUploading
              }, null, 40, _hoisted_17)
            ], 2)
          ])
        ]),
        _createVNode($setup["RemoveDocumentsModal"], {
          "is-open": $setup.showDeleteModal,
          classes: 'delete-modal-high-z',
          onClose: _cache[0] || (_cache[0] = ($event: any) => ($setup.showDeleteModal = false)),
          onConfirm: $setup.confirmDelete
        }, {
          title: _withCtx(() => [...(_cache[5] || (_cache[5] = [
            _createElementVNode("span", null, "Confirm document removal", -1)
          ]))]),
          description: _withCtx(() => [
            _cache[6] || (_cache[6] = _createTextVNode("Are you sure you want to delete '", -1)),
            _createElementVNode("span", _hoisted_18, _toDisplayString($setup.documentToDelete ? $setup.getDocumentName($setup.documentToDelete.fileName) : "") + "'?", 1)
          ]),
          _: 1
        }, 8, ["is-open"])
      ]))
    : _createCommentVNode("", true)
}